import { Popover } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import type { RefObject } from 'react';
import { QuickAddStockForm } from './QuickAddStockForm.tsx';
import type { StockRow } from './StockMatrix.tsx';
import { usePageContext } from '../usePageContext.ts';

export type QuickAddStockProps = {
  readonly api: TypedClient;
  readonly anchor: RefObject<HTMLElement | null>;
  readonly productName: string;
  readonly rows: readonly StockRow[];
  readonly onClose: () => void;
};

export const QuickAddStock = ({ api, anchor, productName, rows, onClose }: QuickAddStockProps) => {
  const { t } = usePageContext();
  return (
    <Popover
      open
      anchor={anchor}
      title={t('quickStock.title')}
      subtitle={productName}
      closeLabel={t('common.close')}
      onClose={onClose}
    >
      <QuickAddStockForm api={api} rows={rows} onRecorded={onClose} />
    </Popover>
  );
};
